/**
 * Canonical CevOp full-screen application bootstrap loader.
 *
 * Use only while a first-party shell cannot yet render (auth/session restore,
 * org bootstrap, PWA cold start). Do not use for local/inline loading.
 *
 * Visual identity is frozen: open-C stroke mark, spark tint, pulse animation.
 * Prefer this over recreating product-specific loaders.
 */
export function CevopAppLoader({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="cevop-app-loader" role="status" aria-live="polite" aria-busy="true" aria-label={label}>
      <span className="cevop-app-loader__mark" aria-hidden>
        <svg className="cevop-app-loader__c" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
          {/* Same open-C geometry as the brand logomark — stroke only, no black tile. */}
          <path
            d="M 372 118 A 158 158 0 1 0 372 394"
            fill="none"
            stroke="currentColor"
            strokeWidth={34}
            strokeLinecap="round"
          />
        </svg>
      </span>
    </div>
  );
}
